// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_G-z","hovered":"aH-z","hoverImage":"bH-z","mainImage":"cH-z","imageNoBackground":"dH-z","fullSizeImage":"eH-z"};